import r from "./_root.js";
var a = r, t = a.Uint8Array, i = t;
export {
  i as default
};
//# sourceMappingURL=_Uint8Array.js.map
